import simpleParallax from 'simple-parallax-js';
import ScrollReveal from 'scrollreveal';
import Swiper from 'swiper/bundle';

export function idxFunc() {
  const image = document.getElementsByClassName('parallax');
  new simpleParallax(image, {
    delay: .6,
    transition: 'cubic-bezier(0,0,0,1)'
  });

  var slideup = {
    delay: 500
  }

  ScrollReveal().reveal('.anm', slideup);

  const swiper = new Swiper('#top-slide', {
    speed: 1200,
    autoplay: {
      delay: 5000,
    },
    effect: 'fade',
  });

}
